export default "__VITE_ASSET__hzNGnC5m__"